export default __webpack_public_path__ + "static/media/chevron-right-blue.7102ce4f.svg";